<template>
    <header class="navbar navbar-tshop navbar-fixed-top megamenu w100" :class="{ stuck: hideNavTop }" role="navigation">
        <div class="navbar-top top-navbar-color">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-6 col-sm-5 col-xs-12 col-md-6">
                        <div class="">
                            <ul class="userMenu ">
                                <li class="phone-number">
                                    <a href="tel:+85239568268" class="tel-style contact-number">
                                        <span><i class="fa fa-phone"></i>
                                            <span class="hidden-xs hidden-sm">電話號碼：</span>
                                        </span>
                                        <span class="m-l-5"> 852-39568268 </span>
                                    </a><br class="hidden-lg hidden-sm hidden-md">
                                    <a href="https://web.whatsapp.com/send?phone=85268493629"
                                       class="tel-style hidden-lg hidden-sm hidden-md contact-number" target="_blank">
                                        <span>
                                            <i class="fa fa-whatsapp"></i>
                                            <span class="hidden-xs">Whatsapp：</span>
                                        </span>
                                        <span class="m-l-5"> 852-68493629 </span>
                                    </a>
                                </li>
                                <li class="hidden-xs">
                                    <a href="https://web.whatsapp.com/send?phone=85268493629" target="_blank">
                                        <span>
                                            <i class="fa fa-whatsapp hidden-xs"></i>
                                            <span class="hidden-sm">Whatsapp：</span>
                                        </span>
                                        <span class="m-l-5"> 852-68493629 </span>
                                    </a>
                                </li>
                                <template v-if="isLogined">
                                    <li class="pull-right hidden-lg hidden-sm hidden-md">
                                        <a href="/logout" @click.prevent="logout()" style="padding:0px">
                                            <span class="hidden-xs"> 登出</span>
                                            <i class="fa fa-sign-out"></i>
                                        </a>
                                    </li>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md header-nav" style="width: 30%">
                                        <router-link :to="{ name: 'account:warehouse' }" class="tel-style">
                                            <i class="fa fa-map-marker"></i>
                                            <span>倉庫地址</span>
                                        </router-link>
                                    </li>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md header-nav" style="width: 30%">
                                        <router-link :to="{ name: 'account:profile' }" class="tel-style">
                                            <i class="fa fa-user"></i>
                                            <span> 賬戶詳情</span>
                                        </router-link>
                                    </li>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md header-nav" style="width: 30%">
                                        <router-link :to="{ name: 'account:order' }"  class="tel-style">
                                            <i class="fa fa-list-alt"></i>
                                            <span>發貨記錄</span>
                                        </router-link>
                                    </li>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md header-nav" style="width: 30%">
                                        <router-link :to="{ name: 'account:index' }" class="tel-style">
                                            <i class="fa fa-list-ul"></i>
                                            <span>貨品認領</span>
                                        </router-link>
                                    </li>
                                </template>
                                <template v-else>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md">
                                        <router-link :to="{ name: 'login' }">登入</router-link>
                                    </li>
                                    <li class="pull-right hidden-lg hidden-sm hidden-md">
                                        <router-link :to="{ name: 'register' }">註冊</router-link>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-6 col-sm-7 col-xs-6 col-md-6 no-margin no-padding hidden-xs">
                        <div class="pull-right">
                            <ul class="userMenu">
                                <template  v-if="isLogined">
                                    <li v-if="member">
                                        <a href="javascript:void(0);" @click="set_account_detail_dialog(true)">
                                            <i class="fa fa-user"></i>
                                            <span class="hidden-xs">
                                            你好， {{ member.nickname || member.email }}</span>
                                        </a>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'account:profile' }">
                                            賬戶詳情
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'account:warehouse' }">
                                            <i class="fa fa-map-marker"></i>
                                            <span class="hidden-xs hidden-sm">倉庫地址</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'account:index' }">
                                            <i class="fa fa-list-ul"></i>
                                            <span class="hidden-xs">貨品認領</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'account:order' }">
                                            <i class="fa fa-list-alt"></i>
                                            <span class="hidden-xs">發貨記錄</span>
                                        </router-link>
                                    </li>
                                    <li>
                                        <a href="/logout" @click.prevent="logout()">
                                            <span class="hidden-xs"> 登出</span>
                                            <i class="fa fa-sign-out"></i>
                                        </a>
                                    </li>
                                </template>
                                <template v-else>
                                    <li>
                                        <router-link :to="{ name: 'login' }">登入</router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{ name: 'register' }">註冊</router-link>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="navbar-header">
                <button type="button" @click="dropDown(xsDropDown)" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                    <span class="sr-only"> Toggle navigation </span>
                    <span class="icon-bar"> </span>
                    <span class="icon-bar"> </span>
                    <span class="icon-bar"> </span>
                </button>
                <router-link to="/" class="navbar-brand">
                    <img :src="logo" alt="Uniports" />
                </router-link>
            </div>

            <div class="navbar-collapse collapse" role="navigation">
                <el-menu default-active="1" class="nav navbar-nav navbar-right hidden-lg hidden-sm hidden-md"
                         background-color="#e9edf3">
                    <el-menu-item index="1">
                       <span slot="title"><router-link to="/"> 首頁 </router-link></span>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <span slot="title"><router-link :to="{ name: 'shares' }">郵包分享</router-link></span>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <span slot="title"><router-link :to="{ name: 'news' }">最新消息</router-link></span>
                    </el-menu-item>
                    <el-submenu index="4">
                        <template slot="title">
                            <span>代運服務</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="4-1">
                                <router-link :to="{ name: 'process' }">代運流程</router-link>
                            </el-menu-item>
                            <el-menu-item index="4-2">
                                <router-link :to="{ name: 'price-list'}">代運收費</router-link>
                            </el-menu-item>
                            <el-menu-item index="4-3">
                                <router-link :to="{ name: 'calculator' }">運費計算</router-link>
                            </el-menu-item>
                            <el-menu-item index="4-4">
                                <router-link :to="{ name: 'notice' }">注意事項</router-link>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="5">
                        <template slot="title">
                            <span>推薦商戶</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="5-1" v-if="zones" v-for="(item, key) in zones" :key="key">
                                <router-link :to="{ name: 'websites', params: { zone_code: key } }">
                                    {{ item }}
                                </router-link>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item index="6">
                        <span slot="title"> <router-link :to="{ name: 'faq' }">常見問題</router-link></span>
                    </el-menu-item>
                    <el-submenu index="7">
                        <template slot="title">
                            <span>聯絡我們</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="7-1">
                                <router-link :to="{ name: 'contact-us' }">聯絡資料</router-link>
                            </el-menu-item>
                            <el-menu-item index="7-2">
                                <router-link :to="{ name: 'about-us' }">關於Uniports</router-link>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
                <el-menu default-active="1" class="nav navbar-nav navbar-right hidden-xs" mode="horizontal">
                    <el-menu-item index="1">
                        <router-link to="/"> 首頁 </router-link>
                    </el-menu-item>
                    <el-menu-item index="2">
                        <router-link :to="{ name: 'shares' }">郵包分享</router-link>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <router-link :to="{ name: 'news' }">最新消息</router-link>
                    </el-menu-item>
                    <el-submenu index="4">
                        <template slot="title"><a href="javascript:">代運服務</a></template>
                        <el-menu-item index="4-1">
                            <router-link :to="{ name: 'process' }">代運流程</router-link>
                        </el-menu-item>
                        <el-menu-item index="4-2">
                            <router-link :to="{ name: 'price-list'}">代運收費</router-link>
                        </el-menu-item>
                        <el-menu-item index="4-3">
                            <router-link :to="{ name: 'calculator' }">運費計算</router-link>
                        </el-menu-item>
                        <el-menu-item index="4-4">
                            <router-link :to="{ name: 'notice' }">注意事項</router-link>
                        </el-menu-item>
                        <el-menu-item index="4-5">
                            <router-link :to="{ name: 'self-raising-address' }">自提地點</router-link>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index="5">
                        <template slot="title"><a href="javascript:">推薦商戶</a></template>
                        <el-menu-item index="5-1" v-if="zones" v-for="(item, key) in zones" :key="key">
                            <router-link :to="{ name: 'websites', params: { zone_code: key } }">
                                {{ item }}
                            </router-link>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item index="6">
                        <router-link :to="{ name: 'faq' }">常見問題</router-link>
                    </el-menu-item>
                    <el-submenu index="7">
                        <template slot="title"><a href="javascript:">聯絡我們</a></template>
                        <el-menu-item index="7-1">
                            <router-link :to="{ name: 'contact-us' }">聯絡資料</router-link>
                        </el-menu-item>
                        <el-menu-item index="7-2">
                            <router-link :to="{ name: 'about-us' }">關於Uniports</router-link>
                        </el-menu-item>
                    </el-submenu>
                </el-menu>
            </div>
        </div>
    </header>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex';
  import logo from '@/assets/logo.png';

  export default {
    name: 'SiteHeader',
    mounted() {
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.addEventListener('scroll', () => {
          this.hideNavTop = window.pageYOffset > 600;
        });
      }
      this.$store.dispatch('fetchWebisteZone');
    },
    data: () => ({
      logo,
      hideNavTop: false,
      xsDropDown: false,

    }),
    computed: {
      ...mapGetters([
        'isLogined',
      ]),
      ...mapState({
        member: state => state.member.identity,
        zones: state => state.website.zones,
      }),
    },
    methods: {
      ...mapMutations(['set_account_detail_dialog']),
      logout() {
        this.$store.dispatch('logout').then(() => {
          if (this.$route.meta.needAuthenticate) {
            // 需要登錄才能訪問的頁面，登出后跳轉到在主頁
            this.$router.push({ name: 'index' });
          }
        });
      },
      dropDown(down) {
        if (down) {
          // eslint-disable-next-line
          $('.navbar-collapse').addClass('in');
          this.xsDropDown = false;
        } else {
          // eslint-disable-next-line
          $('.navbar-collapse').removeClass('in');
          this.xsDropDown = true;
        }
      },
    },
  };
</script>

<style lang="scss">
    .megamenu {
        .el-menu--horizontal {
            background: none;
            border-bottom: none;
            & > .el-menu-item {
                height: 100%;
                border-bottom: none;
                padding: 0;
                &:hover {
                    background: none;
                }
            }
            & > .el-submenu {
                .el-submenu__title {
                    padding: 32px 15px;
                    font-size: 14px;
                    font-weight: 600;
                    height: 100%;
                    line-height: 100%;
                    border-bottom: none;
                    a {
                        color: inherit;
                    }
                    &:hover {
                        background: none;
                    }
                }
                .el-submenu__icon-arrow {
                    margin-left: 3px;
                }
            }
        }
    }
    @media screen and (max-width: 415px) {
        .navbar-toggle {
            margin-top: 10px;
        }
        .navbar-brand {
            padding: 10px;
            height:auto;
        }
        .tel-style {
            line-height: 30px!important;
        }
    }

    @media screen and(min-width: 415px) and (max-width: 768px) {
        .header-nav {
            width: 16% !important;
            overflow:hidden;
            text-overflow:ellipsis!important;
            white-space:nowrap;
        }

        .contact-number {
            line-height: 65px;
            height: 10px;
            margin-left: 10px;
        }

        .userMenu li a {
            padding-right: 12px!important;
        }
    }

    @media screen and(max-width: 320px) {
        .header-nav {
            width: 25% !important;
            overflow:hidden;
            text-overflow:ellipsis!important;
            white-space:nowrap;
        }

        .userMenu li a {
            padding-right: 10px!important;
        }
    }

    .navbar-fixed-bottom .navbar-collapse, .navbar-fixed-top .navbar-collapse {
        max-height: 393px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SiteHeader.vue